import { LinkOutlined } from "@ant-design/icons";
import { Button, Form, Input, Select, Table, message } from "antd";
import printJS from "print-js";
import { useEffect, useState } from "react";
import { ContentBox } from "../../../components/layout/content";
import { LoginedLayout } from "../../../components/layout/loginLayout";
import {
  ALL_LOGISTICS,
  LOGISTIC_MASTER,
  LogisticOption,
  Platform,
  PLATFORM_DELIVERY,
} from "../../../constants/option";
import { GET, POST } from "../../../services";
import {
  CHECKER_GEN_BATCH,
  CHECKER_GEN_BATCH_BY_ORDER,
  CHECKER_GEN_BATCH_FAST_DELIVERY,
  CHECKER_PRINT_BY_BATCH,
  CONSTANT_PLATFORM,
} from "../../../services/path";
import "./style.css";

const { Option } = Select;

const PrintBatch = () => {
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const [formFast] = Form.useForm();
  const [platforms, setPlatforms] = useState<Platform[]>([]);
  const [filteredPlatforms, setFilteredPlatforms] = useState<Platform[]>([]);
  const [filteredFastPlatforms, setFilteredFastPlatforms] = useState<Platform[]>(PLATFORM_DELIVERY);
  const [filteredLogistics, setFilteredLogistics] = useState<LogisticOption[]>(ALL_LOGISTICS);
  const [isloadingGen, setLoadingGen] = useState(false);
  const [isLoadingFast, setIsLoadingFast] = useState(false);
  const [isloadingPrint, setLoadingPrint] = useState(false);
  const [inputData, setInputData] = useState("");

  const [orderNo, setOrderNo] = useState("");
  const [orderInputError, setOrderInputError] = useState(false);
  const [isLoadingOrder, setIsLoadingOrder] = useState(false);
  const [orderResult, setOrderResult] = useState<{
    order_no: string;
    batches: { category: string; batch_id: string }[];
  } | null>(null);

  useEffect(() => {
    const fetchPlatforms = async () => {
      try {
        const data = await GET(CONSTANT_PLATFORM);
        if (!data) {
          throw new Error("Failed to fetch platforms");
        }

        setPlatforms(data);
        setFilteredPlatforms(data); // Initially, filteredPlatforms is the same as the full list
      } catch (error) {
        console.error("Error fetching platforms:", error);
      }
    };

    fetchPlatforms();
  }, []);

  const handleSearch = (value: string) => {
    // Filter platforms based on the search term (case-insensitive)
    const filteredData = platforms.filter((platform) =>
      platform.platf_name.toLowerCase().includes(value.toLowerCase()),
    );

    setFilteredPlatforms(filteredData);
  };

  const handleSearchFast = (value: string) => {
    // Filter platforms based on the search term (case-insensitive)
    const filteredData = PLATFORM_DELIVERY.filter((platform) =>
      platform.platf_name.toLowerCase().includes(value.toLowerCase()),
    );

    setFilteredFastPlatforms(filteredData);
  };

  const handleGenBatch = async () => {
    try {
      setLoadingGen(true);
      const values = form.getFieldsValue();
      const { platform } = values;
      if (platform) {
        const requestBody = {
          platform_id: platform,
          logistic: "",
        };

        const result = await POST(CHECKER_GEN_BATCH, requestBody);
        if (result && result.status === "success") {
          message.success("Batch Focus generated");
        } else {
          message.warning("Batch generated successfully");
        }
      }
    } catch (error) {
      console.error("Error generating batchID:", error);
      message.error("An error occurred while generating Batch ID");
    } finally {
      setLoadingGen(false);
    }
  };

  const handleGenBatchFastDelivery = async () => {
    try {
      setIsLoadingFast(true);
      const values = formFast.getFieldsValue();
      const { platform, logistic } = values;
      if (platform && logistic) {
        const requestBody = {
          logistic: logistic,
          platform_id: platform,
        };

        const result = await POST(CHECKER_GEN_BATCH_FAST_DELIVERY, requestBody);
        if (result && result.message === "Generate Batch and upload PDF successfully") {
          message.success("Batch Fast Delivery generated");
        } else {
          message.warning("Batch generated successfully");
        }
      }
    } catch (error) {
      console.error("Error generating batchID:", error);
      message.error("An error occurred while generating Batch ID");
    } finally {
      setIsLoadingFast(false);
    }
  };

  const handlePlatformChange = (platId: number | null) => {
    if (!platId) {
      setFilteredLogistics(ALL_LOGISTICS);
      formFast.setFieldsValue({ logistic: undefined });
      return;
    }

    const allowedValues = LOGISTIC_MASTER[platId] || [];
    const filtered = ALL_LOGISTICS.filter((item) => allowedValues.includes(item.value));
    setFilteredLogistics(filtered);
    formFast.setFieldsValue({ logistic: filtered[0]?.value });
  };

  const handleGenBatchByOrder = async () => {
    if (!orderNo.trim()) {
      setOrderInputError(true);
      return;
    }
    setOrderInputError(false);
    setIsLoadingOrder(true);
    setOrderResult(null);
    try {
      const data = await POST(CHECKER_GEN_BATCH_BY_ORDER(orderNo.trim()), {});
      if (data?.result) {
        setOrderResult(data.result);
      } else {
        message.error(data?.message || "เกิดข้อผิดพลาดกรุณาตรวจสอบเลขที่ออเดอร์");
      }
    } catch (err: any) {
      message.error(err?.response?.data?.message || "เกิดข้อผิดพลาดกรุณาตรวจสอบเลขที่ออเดอร์");
    } finally {
      setIsLoadingOrder(false);
    }
  };

  const LinktoPrintBatchURL = () => {
    const printUrl = process.env.REACT_APP_PRINT_BATCH_URL;
    window.open(printUrl, "_blank");
  };

  const handlePrintByBatch = async () => {
    try {
      setLoadingPrint(true);
      const values = form2.getFieldsValue();
      const { batchID } = values;
      const baseUrl = process.env.REACT_APP_WAYBILL_URL + "/";
      if (batchID) {
        const requestBody = {
          BatchID: batchID,
        };

        const response = await POST(CHECKER_PRINT_BY_BATCH, requestBody);
        if (response && response.file_path !== null) {
          const filePath = baseUrl + response.file_path;
          if (filePath) {
            printJS(filePath);
          }

          message.success("Succes: รอ print batch");
        } else if (response && response.file_path === null) {
          message.warning("Warning: batch นี้ถูก pick ไปแล้ว");
        } else {
          message.error("ERROR: เกิดข้อผิดพลากบางอย่างกรุณาตรวจสอบ ฺBatch ID");
        }
      }
    } catch (error) {
      console.error("Error generating batchID:", error);
      message.error("ERROR: เกิดข้อผิดพลากบางอย่างกรุณาตรวจสอบ ฺBatch ID");
    } finally {
      setLoadingPrint(false);
    }
  };

  return (
    <LoginedLayout>
      <ContentBox>
        <div
          style={{ marginBottom: "16px", borderBottom: "1px solid #e8e8e8", paddingBottom: "8px" }}
        >
          <h2 style={{ marginBottom: "8px" }}>Generate Batch</h2>
        </div>
        <div style={{ padding: 16 }}>
          <Form form={form} onFinish={handleGenBatch} initialValues={{ brand: "focus" }}>
            <Form.Item
              name="platform"
              label="Select Platform"
              rules={[{ required: true, message: "Please select a platform" }]}
            >
              <Select
                showSearch
                placeholder="Select a platform"
                filterOption={false} // Disable default filtering
                onSearch={handleSearch}
                notFoundContent={null}
                allowClear
                onClear={() => setFilteredPlatforms(platforms)} // Reset to full list when cleared
              >
                {filteredPlatforms.map((platform) => (
                  <Option key={platform.platf_id} value={platform.platf_id}>
                    {platform.platf_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="brand"
              label="Select Brand"
              rules={[{ required: true, message: "Please select a Brand" }]}
            >
              <Select placeholder="Select a Brand" defaultValue="focus" disabled>
                <Option value="focus">Focus</Option>
              </Select>
            </Form.Item>
            <div style={{ display: "flex", marginTop: "10px" }}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isloadingGen}
                  style={{ alignItems: "center" }}
                >
                  Generate Batch No
                </Button>
              </Form.Item>
              <Button
                type="link"
                onClick={LinktoPrintBatchURL}
                style={{ alignItems: "start", color: "blue" }}
              >
                <LinkOutlined /> ไปหน้า print Batch
              </Button>
            </div>
          </Form>
        </div>
      </ContentBox>

      <ContentBox style={{ marginTop: "3vh" }}>
        <div
          style={{ marginBottom: "16px", borderBottom: "1px solid #e8e8e8", paddingBottom: "8px" }}
        >
          <h2 style={{ marginBottom: "8px" }}>Gen Batch Fast Delivery</h2>
        </div>
        <div style={{ padding: 16 }}>
          <Form
            form={formFast}
            onFinish={handleGenBatchFastDelivery}
            initialValues={{ logistic: "Express Delivery (SHP Food)" }}
          >
            <Form.Item
              name="platform"
              label="Select Platform"
              rules={[{ required: true, message: "Please select a platform" }]}
            >
              <Select<number>
                showSearch
                placeholder="Select a platform"
                filterOption={false} // Disable default filtering
                onSearch={handleSearchFast}
                notFoundContent={null}
                allowClear
                onClear={() => setFilteredFastPlatforms(PLATFORM_DELIVERY)} // Reset to full list when cleared
                onChange={handlePlatformChange}
              >
                {filteredFastPlatforms.map((platform) => (
                  <Option key={platform.platf_id} value={platform.platf_id}>
                    {platform.platf_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="logistic"
              label="Select Logistic"
              rules={[{ required: true, message: "Please select a Logistic" }]}
            >
              <Select<string> placeholder="Select a Logistic">
                {filteredLogistics.map((log) => (
                  <Option key={log.value} value={log.value}>
                    {log.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <div style={{ display: "flex", marginTop: "10px" }}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoadingFast}
                  style={{ alignItems: "center" }}
                >
                  Batch Fast Delivery
                </Button>
              </Form.Item>
            </div>
          </Form>
        </div>
      </ContentBox>
      <ContentBox style={{ marginTop: "3vh" }}>
        <div
          style={{ marginBottom: "16px", borderBottom: "1px solid #e8e8e8", paddingBottom: "8px" }}
        >
          <h2 style={{ marginBottom: "8px" }}>Print Batch</h2>
        </div>
        <div style={{ padding: 16 }}>
          <Form form={form2} onFinish={handlePrintByBatch}>
            <Form.Item
              name="batchID"
              label="Batch ID"
              rules={[{ required: true, message: "กรุณาใส่ Batch ID" }]}
            >
              <Input
                placeholder="กรุณาใส่ batch ID "
                value={inputData}
                onChange={(e) => setInputData(e.target.value)}
              />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={isloadingPrint}>
                Print By Batch
              </Button>
            </Form.Item>
          </Form>
        </div>
      </ContentBox>
      <ContentBox style={{ marginTop: "3vh" }}>
        <div className="gbo-section-header">
          <h2>Generate Batch by Order</h2>
        </div>
        <div className="gbo-content">
          <Form.Item
            label={
              <span>
                <span className="gbo-required-mark">*</span> Order No
              </span>
            }
          >
            <Input
              placeholder="กรุณาใส่เลขที่ Order"
              value={orderNo}
              status={orderInputError ? "error" : ""}
              onChange={(e) => {
                setOrderNo(e.target.value);
                if (orderInputError) setOrderInputError(false);
              }}
              onPressEnter={handleGenBatchByOrder}
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" loading={isLoadingOrder} onClick={handleGenBatchByOrder}>
              Generate Batch
            </Button>
          </Form.Item>

          {orderResult && (
            <>
              <hr className="gbo-divider" />
              <div className="gbo-result-header">
                <span className="gbo-result-label">ผลลัพธ์ Batch</span>
                <span className="gbo-order-badge">Order: {orderResult.order_no}</span>
              </div>

              <div className="gbo-success-banner">
                ✅ สร้าง Batch สำเร็จ · <strong>{orderResult.batches.length}</strong> Batch
              </div>
              <Table
                size="small"
                pagination={false}
                dataSource={orderResult.batches.map((b, i) => ({ ...b, key: i }))}
                columns={[
                  {
                    title: "#",
                    width: 48,
                    render: (_: any, __: any, index: number) => (
                      <span className="gbo-row-index">{index + 1}</span>
                    ),
                  },
                  {
                    title: "Category",
                    dataIndex: "category",
                    render: (cat: string) => (
                      <span
                        className={`gbo-category-badge gbo-category-badge--${cat.toLowerCase()}`}
                      >
                        {cat}
                      </span>
                    ),
                  },
                  {
                    title: "Batch ID",
                    dataIndex: "batch_id",
                    render: (id: string) => <span className="gbo-batch-id">{id}</span>,
                  },
                ]}
              />
            </>
          )}
        </div>
      </ContentBox>
    </LoginedLayout>
  );
};

export default PrintBatch;
